import styled from "styled-components";

const LandingPageWrapper = styled.div`
   .h1 .h2, .h3, .h4, .h5, .h6, .a, .p, .div, .body {
    font-family: 'Glacial-Regular'
   }
`;

export default LandingPageWrapper;
